<div class="toolbar-container">
  <app-timeline-toggle-expand></app-timeline-toggle-expand>
  <app-timeline-view-type></app-timeline-view-type>
  <app-timeline-export></app-timeline-export>
</div>
